import API from "../../api/api";

const callGetApi = async (endpoint, params) => {
  try {
    const response = await API.get(endpoint, { params });
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  } catch (error) {
    throw error;
  }
};

export const GenealogyService = {
  getTreelist: async (plan,userId, userName) => {
    return callGetApi(`get-genealogy-tree?userId=${userId}&username=${userName}&treePlan=${plan}`)
  },
  getUnilevelMore: async (fatherId, position) => {
    const endpoint = `get-unilevel-more`;
    const params = { fatherId: fatherId, position: position }
    return callGetApi(endpoint, params);
  }
};

export const TreeViewService = {
  getTreelist: async (treePlan,userId) => {
    return callGetApi(`get-tree-view?userId=${userId}&treePlan=${treePlan}`)
  },
};

export const SponserTreeService = {
  getTreelist: async (treePlan,userId, userName) => {
    return callGetApi(`get-sponsor-tree?userId=${userId}&username=${userName}&treePlan=${treePlan}`)
  },
  getSponserTreeMore: async (treePlan,sponsorId, position) => {
    return callGetApi(`get-sponsor-tree-more?treePlan=${treePlan}&sponsorId=${sponsorId}&position=${position}`)
  }
}

export const DownlineMembersService = {
  callDownline: async (plan,level, page, itemsPerPage) => {
    const endpoint = `get-downlines`;
    const params = { level: level, page: page, perPage: itemsPerPage,treePlan:plan }
    return callGetApi(endpoint, params);
    // return callApi(`get-downlines?level=${level}&page=${page}&perPage=${itemsPerPage}`)
  },
  callHeader: async (plan) => {
    const endpoint = `get-downline-header?treePlan=${plan}`;
    return callGetApi(endpoint);
  }
}

export const ReferralMembersService = {
  callReferral: async (treePlan, level, page, itemsPerPage) => {
    const endpoint = `get-referrals`;
    const params = { level: level, page: page, perPage: itemsPerPage, treePlan: treePlan }
    return callGetApi(endpoint, params);
  },
  callHeader: async (treePlan) => {
    const endpoint = `get-referral-header?treePlan=${treePlan}`;
    return callGetApi(endpoint);
  }
}

